import content from '../../public/assets/content/copy.json'

/**
 * Sets page title for routes with set `meta` property
 * @param {Object} to route property
 * Note: Article and Section (Article Categories) cannot have title
 * in meta property since it is only known when loaded. Those are set
 * in the vue file respectively
 */
const setPageTitle = titleText => {
  const prefix = titleText || content.page_title_text
  window.document.title = `${prefix} ${content.page_title_suffix}`
}

const setPageCanonicalLink = linkPath => {
  const canonicalLink = window.document.querySelector('link[rel="canonical"]')
  if (canonicalLink && linkPath) {
    canonicalLink.href = linkPath
    return canonicalLink.href
  }
  return null
}

export { setPageTitle, setPageCanonicalLink }
